import { render, staticRenderFns } from "./CustomerDetails.vue?vue&type=template&id=9fb2222e"
import script from "./CustomerDetails.vue?vue&type=script&lang=js"
export * from "./CustomerDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetails.vue?vue&type=style&index=0&id=9fb2222e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports